import { VcsProvider, GithubIntegration, OriginIntegration } from "types/generated";

export type VcsProviderInSpacesGql = {
  providersInSpace: VcsProvider[];
  githubIntegration: GithubIntegration | undefined;
  originIntegration: OriginIntegration | undefined;
};

export type InternalFormData = {
  workerPoolLabel?: string;
  spaceLabel?: string;
  vcsIntegrationLabel?: string;
  useGitCheckout?: boolean;
};

export type SourceCodeSettingsField = {
  provider?: VcsProvider;
  repository: string;
  vcsIntegrationId?: string;
  namespace: string;
  repositoryURL?: string;
  branch: string;
  projectRoot: string;
  gitSparseCheckoutPaths?: Record<"value", string>[];
};

export enum SourceCodeFields {
  Repository = "repository",
  Branch = "branch",
  ProjectRoot = "projectRoot",
  RepositoryURL = "repositoryURL",
  Provider = "provider",
  Integration = "integration",
}

export enum SourceCodeProjects {
  Stack = "stack",
  Module = "module",
}
